import { Button, Col, Form, Input, Row, Space, Modal } from "antd";
import Password from "antd/lib/input/Password";
import "crypto-js/lib-typedarrays";
import Amplify, { API, Auth } from "aws-amplify";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";
import {
  login,
  PlayerMode,
  setPlayerMode,
  updateAccount,
} from "../../../features/player/playerSlice";
import { CheckAccountStateQuery } from "../../../API";
import { checkAccountState } from "../../../graphql/queries";
import { GRAPHQL_AUTH_MODE, GraphQLResult } from "@aws-amplify/api-graphql";
import { useAppSelector } from "../../../app/hooks";
import { selectTheme, ThemeMode } from "../../../features/theme/themeSlice";

type Props = {
  onLoginSuccess: () => void;
};

type CognitoException = {
  name: string;
  code: any;
};

const modalLoginError = (message: string) => {
  Modal.error({
    content: <p>{message}</p>,
  });
};

const modalInfo = (message: string) => {
  Modal.info({
    content: <p>{message}</p>,
  });
};

const LoginForm = ({ onLoginSuccess }: Props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [formInError, setFormInError] = useState(false);
  const [resetModalVisible, setResetModalVisible] = useState<boolean>(false);
  const [resetUsername, setResetUsername] = useState<string>("");
  const [codeShipped, setCodeShipped] = useState<boolean>(false);
  const [verificationCode, setVerificationCode] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [loginButtonDisabled, setLoginButtonDisabled] = useState(false);
  const theme = useAppSelector(selectTheme);
  const dispatch = useDispatch();
  
  useEffect(() => {}, [username, password]);

  const loginFn = async () => {
    setLoginButtonDisabled(true);
    try {
      if (!formInError && username !== "" && password !== "") {
        const user = await Auth.signIn({
          username: username,
          password: password,
        });
        const groups =
          user.signInUserSession.accessToken.payload["cognito:groups"];
        const { email } = user.attributes;
        if (
          theme.mode === ThemeMode.DEFAULT &&
          !(groups.indexOf("Players") > -1)
        ) {
          const g = groups.join(" - ");
          Modal.error({
            title: "Errore login",
            content: <p>{g} non autorizzati/o!</p>,
          });
          Auth.signOut();
          return;
        }
        if (groups.indexOf("kiosks") > -1) {
          //  dispatch(setPlayerMode(PlayerMode.KIOSK));
        }

        dispatch(login({ username: username, email: email, groups: groups }));
        if (onLoginSuccess) {
          onLoginSuccess();
        }
        (async () => {
          const result: GraphQLResult<CheckAccountStateQuery> =
            (await API.graphql({
              query: checkAccountState,
              authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
              variables: {
                username: user.username,
              },
            })) as GraphQLResult<CheckAccountStateQuery>;

          dispatch(updateAccount(result.data.checkAccountState));
        })();
      }
    } catch (e) {
      setLoginButtonDisabled(false);
      const error = e as CognitoException;
      if (error.name === "UserNotFoundException")
        modalLoginError("User not found exception");
      else modalLoginError(error.name);
      console.log("error", e);
    }
  };

  return (
    <div className="login-form">
      <Form>
        <Row justify="end" align="top" gutter={10}>
          <Col>
            <Input
              className={`username-input ${
                formInError ? "input-error input-login-required" : ""
              }`}
              name="username"
              placeholder="username"
              onChange={(evt) => {
                setFormInError(false);
                setUsername(evt.target.value);
              }}
            />
            {formInError && (
              <div className="login-required-field-error">
                <FormattedMessage id="login.required.field" />
              </div>
            )}
          </Col>
          <Col>
            <Password
              className={`password-input ${
                formInError ? "input-error input-login-required" : ""
              }`}
              name="password"
              placeholder="password"
              onChange={(evt) => {
                setFormInError(false);
                setPassword(evt.target.value);
              }}
            />
            {formInError && (
              <div className="login-required-field-error">
                <FormattedMessage id="login.required.field" />
              </div>
            )}
            <div
              className="d-forgot-password pointer"
              style={{ textAlign: "right", color: "white" }}
              onClick={() => {
                setResetModalVisible(true);
              }}
            >
              <FormattedMessage id="login.forgot.password" />
            </div>
          </Col>
          <Col></Col>
          <Col>
            <Button
              className="login-button with-border"
              htmlType="submit"
              onClick={(e) => {
                if (username === "" || password === "") {
                  setFormInError(true);
                  return;
                }
                loginFn();
              }}
              type="primary"
              disabled={loginButtonDisabled}
            >
              Login
            </Button>
          </Col>
          {/**  
         <Col>
            <Link
              to="/register"
              className="ant-btn ant-btn-default register-btn with-border "
            >
              <FormattedMessage id="register" />
            </Link>
          </Col>
          */}
        </Row>
      </Form>
      <Modal
        title="Reset password"
        visible={resetModalVisible}
        onOk={() => {
          setResetModalVisible(false);
          if (!codeShipped) {
            Auth.forgotPassword(resetUsername)

              .then((data) => {
                modalInfo(data.message);
              })
              .catch((err) => modalLoginError(err.message));
          } else {
            Auth.forgotPasswordSubmit(
              resetUsername,
              verificationCode,
              newPassword
            )
              .then((data) => {
                modalInfo(data);
                setCodeShipped(false);
                setResetUsername("");
                setVerificationCode("");
                setNewPassword("");
              })
              .catch((err) => {
                modalLoginError(err.message);
              });
          }
        }}
        onCancel={() => {
          setResetModalVisible(false);
          setResetUsername("");
          setVerificationCode("");
          setNewPassword("");
        }}
      >
        <Form layout="vertical">
          <Form.Item label="username">
            <Input
              placeholder="username"
              value={resetUsername}
              defaultValue={resetUsername}
              onChange={(evt) => setResetUsername(evt.target.value)}
            />
          </Form.Item>
          {codeShipped && (
            <>
              <Form.Item label="Code">
                <Input
                  placeholder="code"
                  value={verificationCode}
                  defaultValue={verificationCode}
                  onChange={(evt) => setVerificationCode(evt.target.value)}
                />
              </Form.Item>
              <Form.Item label="New password">
                <Password
                  value={newPassword}
                  onChange={(evt) => setNewPassword(evt.target.value)}
                />
              </Form.Item>
            </>
          )}
        </Form>
      </Modal>
    </div>
  );
};

export default LoginForm;
